import { z } from 'zod'
import { t } from '@/lib/helpers'
import { USER_ROLE_OPTIONS } from '../constants'

const userRoleValues = USER_ROLE_OPTIONS.map((role) => role.value) as [
  string,
  ...string[]
]

export const editUserSchema = z.object({
  folder_permissions: z.any().array(),
  role: z.enum(userRoleValues),
})

export const createUserSchema = editUserSchema.extend({
  email: z
    .string()
    .email({
      message: t('views.shared.form.invalid_email', undefined, 'Invalid Email'),
    })
    .nonempty({
      message: t('views.shared.input.required', undefined, 'Required'),
    }),
  role: z.enum(userRoleValues),
})
